import { ApiClient } from "lib/utils/client/apiClient";

/**
 * Create a new condo
 * POST /condos
 */
export const createCondo = async (data: {
  name: string;
  condoNumber?: string;
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  totalUnits?: number;
  description?: string;
}) => {
  return ApiClient('/condos', {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

/**
 * Get all condos with pagination
 * GET /condos?page=1&limit=10
 */
export const getAllCondos = async (params?: { page?: number; limit?: number }) => {
  const queryParams = new URLSearchParams();
  if (params?.page) queryParams.append('page', params.page.toString());
  if (params?.limit) queryParams.append('limit', params.limit.toString());
  
  const queryString = queryParams.toString();
  const url = `/condos${queryString ? `?${queryString}` : ''}`;
  
  return ApiClient(url, {
    method: 'GET',
  });
};

/**
 * Get condo by ID
 * GET /condos/:id
 */
export const getCondoById = async (id: string) => {
  return ApiClient(`/condos/${id}`, {
    method: 'GET',
  });
};

